import CountBadge from '@/components/elements/CountBadge/CountBadge';
import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers';
import { customTwMerge } from '@/helpers/theme';
import { HTMLAttributes } from 'react';

type DropdownProps = HTMLAttributes<HTMLButtonElement> & {
  toggleOpen: () => void;
  close?: () => void;
  isActive: boolean;
  activeBadge?: number;
  variant?: 'primary' | 'secondary' | 'tertiary';
  large?: boolean;
  block?: boolean;
  label?: string;
  icon?: React.ReactNode;
  buttonRef?: React.Ref<HTMLButtonElement>;
  iconPosition?: 'left' | 'right';
};

export const DropdownButton = ({
  className = '',
  children = null,
  icon = null,
  isActive = false,
  toggleOpen = null,
  close,
  activeBadge = 0,
  buttonRef = null,
}: DropdownProps) => {
  return (
    <button
      className={customTwMerge(
        classnames(
          'text-m border-border_regular px-xs relative flex h-[32px] items-center justify-center rounded-lg border outline-none',
          className,
        ),
      )}
      ref={buttonRef}
      onClick={() => {
        toggleOpen();
      }}>
      {icon && (
        <span className={classnames('flex flex-shrink-0 items-center justify-center', children && 'mr-xxs')}>
          {icon}
        </span>
      )}
      {children}
      {!!toggleOpen && (close || Boolean(activeBadge)) && (
        <>
          {isActive && close ? (
            <Icon
              style={{ width: 16, height: 16 }}
              variant={'close'}
              onClick={(e) => {
                e.stopPropagation();
                close();
              }}
              size="xs"
            />
          ) : (
            isActive &&
            Boolean(activeBadge > 0) && (
              <span className="pl-xs">
                <CountBadge count={activeBadge} />
              </span>
            )
          )}
        </>
      )}

      {
        <Icon
          style={{ width: 16, height: 16 }}
          className={classnames('flex flex-shrink-0 items-center justify-center transition duration-100 ease-in-out', {
            'rotate-180': isActive,
          })}
          variant={'chevron-s-down'}
          size="xs"
        />
      }
    </button>
  );
};
